import { render, staticRenderFns } from "./confidential_issue_sidebar.vue?vue&type=template&id=244a9bb6&"
import script from "./confidential_issue_sidebar.vue?vue&type=script&lang=js&"
export * from "./confidential_issue_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports